module.exports = __webpack_public_path__ + "static/media/gift-give-box-svgrepo-com.79c99b47.svg";